/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class Disclaimer {
  private json: any
  public readonly disclaimerClose: string
  public readonly disclaimerText: string
  public readonly disclaimerTitle: string

  constructor (data: any) {
    this.json = data
    this.disclaimerClose = this.json.disclaimer_close_label
    this.disclaimerText = this.json.disclaimer_text
    this.disclaimerTitle = this.json.disclaimer_title
  }

  static of (data: any): Disclaimer {
    return new Disclaimer(data)
  }

  static empty (): Disclaimer {
    return new Disclaimer({
      disclaimer_close_label: '',
      disclaimer_text: '',
      disclaimer_title: ''
    })
  }
}
